module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/babel-runtime/core-js/symbol.js
// module id = 842
// module chunks = 0